/**
 * @hidden
 */
var BaseEvent = /** @class */ (function () {
    /**
     * @hidden
     */
    function BaseEvent(target) {
        this.target = target;
    }
    return BaseEvent;
}());
export { BaseEvent };
//# sourceMappingURL=base-event.js.map